import { signInWithRedirect, signOut, fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';
import { UserSession } from '../types/user-session';

export const signOutUser = () => signOut();

export const signInUser = () =>
  signInWithRedirect({
    provider: { custom: `chatbot-${import.meta.env.VITE_ENV}-cognito` }
  });

export const getCognitoSession = async (): Promise<UserSession | undefined> => {

  try {
    // Get current user details if there is one
    await getCurrentUser();
    // User is signed in
    const authSession = await fetchAuthSession({ forceRefresh: true });

    if (!authSession || !authSession.tokens) {
      console.log('No tokens found in auth session');
      return undefined;
    }

    return {
      curtinId: authSession.tokens.idToken?.payload?.['custom:curtinid']?.toString().toUpperCase() || '',
      userType: authSession.tokens.idToken?.payload?.['custom:user_type']?.toString().toUpperCase() || '',
      userGroups: authSession.tokens?.idToken?.payload?.['custom:groups']?.toString() || '',
      accessToken: authSession.tokens.accessToken.toString(),
      idToken: authSession.tokens.idToken?.toString() || '',
      givenName: authSession.tokens.idToken?.payload?.given_name?.toString() || '',
    }
  } catch {
    // User is signed out
    console.log('No tokens or valid current user found in auth session');
    return undefined;
  }
};

export const userSessionProvider = async (): Promise<UserSession | undefined> => {
  const session = await getCognitoSession();

  if (session) return session;

  console.log('User session not found');

  // console.log('No session found after retries, initiating sign in...');
  // await signInUser();
  return undefined;
};
